import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';

const styles = {
  controlsContainer: {
    display: 'flex',
    gap: '16px',
    marginTop: '20px',
  },
};

const Controls = ({ onClear, onPredict, isLoading }) => {
  return (
    <Box sx={styles.controlsContainer}>
      <Button variant="outlined" color="secondary" onClick={onClear} disabled={isLoading}>
        クリア
      </Button>
      <Button variant="contained" color="primary" onClick={onPredict} disabled={isLoading} sx={{ minWidth: '120px' }}>
        {isLoading ? <CircularProgress size={24} color="inherit" /> : '推論実行'}
      </Button>
    </Box>
  );
};

export default Controls;
